import {Component} from '@angular/core';

@Component({
    selector: 'app-service-orders-invoice',
    templateUrl: './service-orders-invoice.component.html',
    styleUrl: './service-orders-invoice.component.scss'
})
export class ServiceOrdersInvoiceComponent {

}
